<section class="home-section">
  <div *ngIf="isSkeleton; then skeletonWrap else defaultWrap"></div>
  <ng-template #skeletonWrap>
    <div class="skeleton-container">
      <div class="skeleton-wrap-store" *ngFor="let skeleton of skeletonLocations">
        <ion-thumbnail class="skeleton-header" slot="start">
          <ion-skeleton-text animated></ion-skeleton-text>
        </ion-thumbnail>
        <p>
          <ion-skeleton-text animated style="width: 80%"></ion-skeleton-text>
        </p>
        <p>
          <ion-skeleton-text animated style="width: 60%"></ion-skeleton-text>
        </p>
      </div>
    </div>
  </ng-template>
  <ng-template #defaultWrap>
    <div class="select-category-wrap" *ngIf="merchant.categoryFilterEnabled">
      <mat-form-field class="">
        <mat-label>Select category to filter locations</mat-label>
        <mat-select [(ngModel)]="selectedCategory">
          <mat-option (click)="filterRestaurants(null)">None</mat-option>
          <mat-option *ngFor="let catalog of merchantCatalog" (click)="filterRestaurants(catalog.locationIds)" [value]="catalog.locationIds">
            {{catalog.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="content-wrap">
      <div class="locations-wrap" #scrollContainer>
        <div class="title-wrap">
          <div class="locations-desc">
            Locations near you 
            <span class="locations-desc-num">
              ({{getRestaurants().length}})
            </span>
          </div>
        </div>
        <div class="location-container"
             *ngFor="let restaurant of getRestaurants()"
             (click)="openMarker(restaurant)"
             [class.location-selected]="selectedRestaurant && restaurant.locationId === selectedRestaurant.locationId && restaurant.name == selectedRestaurant.name">
          <div class="restaurant-info-wrap">
            <div class="location-name">
              {{restaurant.name}}
            </div>
            <div class="location-address">
              {{restaurant.address.addressLine}}
            </div>
            <div class="distance-wrap" *ngIf="restaurant?.distance">
              {{restaurant.distance}} miles away
            </div>
            <mat-accordion>
              <mat-expansion-panel 
              class="time-panel"
              #expansionPanel
              [ngClass]="{
                'panel-closed': !expansionPanel.expanded,
                'panel-opened': expansionPanel.expanded
              }"
              *ngIf="restaurant.isShowHours"
              >
                <mat-expansion-panel-header class="time-header">
                  <mat-panel-title class="time-title">
                    <span class="material-icons icon-color icon-wrap">access_time</span>
                    {{restaurantWorkDays(restaurant)[0] | titlecase}} {{restaurantWorkHours(restaurant)[0]}}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="store-hours-wrap" *ngFor="let hours of getRestaurantHours(restaurant) | slice:1">
                  <span class="day-highlight">
                    {{hours.day}}
                  </span>
                  <span>
                    {{hours.info}}
                  </span>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
          <button mat-button class="shop-btn" (click)="merchant.useFlavorShiftsTime ? openShiftSelectionModal(restaurant.name) : goToRestaurantPage(restaurant.locationId)">Start Order</button>
        </div>
      </div>
      <div class="map-wrap">
        <google-map width="100%" height="100%" [center]="center" [zoom]="zoom" [options]="mapOptions">
          <map-marker [position]="userPosition" [options]="markerUserOptions"></map-marker>
          <ng-container *ngFor="let mark of restaurantMarks">
            <map-marker #marker
                        [position]="mark.position"
                        [options]="mark.markerOptions"
                        (mapClick)="openInfoWindow(marker, mark.options)"
                        ></map-marker>
          </ng-container>
          <map-info-window [options]="{headerDisabled:true}" (closeclick)="onInfoWindowClose()">
            <div class="marker-wrap">
              <h3>{{selectedMarkInfo.title}}</h3>
              <p>{{selectedMarkInfo.number}}</p>
              <p>{{selectedMarkInfo.address}}</p>
              <button class="google-map-order-btn" (click)="merchant.useFlavorShiftsTime ? openShiftSelectionModal(selectedMarkInfo.title) : goToRestaurantPage(selectedMarkInfo.locationId)">Start Order</button>
            </div>
          </map-info-window>
        </google-map>
      </div>
    </div>
  </ng-template>
</section>
